import { Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-registro-exitoso',
  templateUrl: './registro-exitoso.component.html',
  styleUrl: './registro-exitoso.component.scss',
  standalone: false
})
export class RegistroExitosoComponent {
  @Input() estatus?: string = '';

  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params: any) => {
      if (typeof(params.estatus) != 'undefined') {
        this.estatus = params.estatus;
      }
    });
  }

}
